module.exports = __webpack_public_path__ + "common/icon-share-button-177ae6dad3037aaeda2af8f053cdf0a1.svg";